import { Box, BoxProps, styled } from '@mui/material';

export const Loading = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));
